import { render, staticRenderFns } from "./MemberLabels.vue?vue&type=template&id=5ea3ac2c&"
import script from "./MemberLabels.vue?vue&type=script&lang=js&"
export * from "./MemberLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports